/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import {
  Input,
  InputAdornment,
  MenuItem,
  Typography,
  makeStyles,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'

import SearchIcon from '@material-ui/icons/Search'
import { KeyboardDatePicker } from '@material-ui/pickers'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import InputMask from 'react-input-mask'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'

import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import SelectField from '../../components/SelectField'
import {
  mdiAccountSearch,
  mdiFilterMultiple,
  mdiNoteEditOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import colors from '../../../assets/colors'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import formComponentStyles from '../../../assets/formComponentsStyles'

import { useHistory, useLocation, Link } from 'react-router-dom'
import { format, isValid } from 'date-fns'
import { useNavigator } from '../../../hooks/useNavigator'

export default function Filter(props) {
  const statuses = useSelector(state => state.attendance.status)
  const attendants = useSelector(state => state.attendance.attendants)

  const filterClasses = filterStylesComponents()
  const formClasses = formComponentStyles()
  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location?.search)

  const { classes } = props
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  const navigator = useNavigator()

  const [form, setForm] = useState({
    attendant: '',
    status: '',
    date_end: '',
    date_start: '',
  })

  const [open, setOpen] = useState(false)

  const toggleModal = () => {
    setOpen(!open)
  }

  const statusFiltered = useMemo(() => {
    if (!statuses?.length) return ''
    if (!filters?.status_id) return ''
    return statuses?.find(r => r?.id == filters?.status_id)
  }, [statuses, filters])

  const attendanceFiltered = useMemo(() => {
    if (!statuses?.length) return ''
    if (!filters?.attendance_id) return ''
    return attendants?.find(r => r?.id == filters?.attendance_id)
  }, [attendants, filters])

  const onSubmit = (data = form) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleChangeDate = (date, name) => {
    setForm({
      ...form,
      [name]: date,
    })
  }

  const handleChangeAttendance = (name, value) => {
    const data = {
      ...form,
      [name]: value,
    }

    setForm(data)
  }

  const handleChangeStatus = (name, value, dispatch = false) => {
    const data = {
      ...form,
      [name]: value,
    }

    setForm(data)

    if (dispatch) {
      const values = {
        ...filters,
        status_id: value?.id || '',
      }
      onSubmit(values)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)

    data.append('status_id', form.status?.id || '')
    data.append('attendance_id', form.attendant?.id || '')

    data.append(
      'date_start',
      form.date_start && isValid(form.date_start)
        ? format(form.date_start, 'yyyy-MM-dd')
        : ''
    )

    data.append(
      'date_end',
      form.date_end && isValid(form.date_end)
        ? format(form.date_end, 'yyyy-MM-dd')
        : ''
    )

    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  useEffect(() => {
    if (!statusFiltered) return
    setForm({ ...form, status: statusFiltered })
  }, [statusFiltered])

  useEffect(() => {
    if (!attendanceFiltered) return
    setForm({ ...form, attendant: attendanceFiltered })
  }, [attendanceFiltered])

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={8}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={2} alignItems="center">
                <Grid item sm={4} xs={12}>
                  <Input
                    fullWidth
                    name="name"
                    defaultValue={filters?.name || ''}
                    id="standard-adornment-person"
                    style={{ marginTop: '16px' }}
                    placeholder="Pesquise por cliente"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton aria-label="search person" type="submit">
                          <Icon path={mdiAccountSearch} size={1} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
                <Grid sm={4} xs={12}>
                  <SelectField
                    options={statuses}
                    setForm={(name, value) =>
                      handleChangeStatus(name, value, true)
                    }
                    data={form.status || ''}
                    variant="standard"
                    name="status"
                    label="Filtre por status"
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>

          <Grid item xs>
            <Grid
              container
              spacing={2}
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item>
                {canCreate('atendimentos', permissionUser) && (
                  <Button
                    onClick={toggleModal}
                    style={{ color: colors.textPrimary }}
                    className={filterClasses.btnMoreFilters}
                  >
                    <Icon
                      path={mdiFilterMultiple}
                      className={classes.btnIcon}
                      size={1}
                      color={colors.secondary}
                    />
                    Outros filtros
                  </Button>
                )}
              </Grid>
              <Grid item>
                {canCreate('atendimentos', permissionUser) && (
                  <IconButton
                    component={Link}
                    className={filterClasses.btnAdd}
                    to="/attendance/new"
                  >
                    <Icon
                      path={mdiNoteEditOutline}
                      size={1}
                      style={{ marginRight: '4px' }}
                    />
                    Cadastrar
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <BaseFilterModal
        open={open}
        handleOpen={toggleModal}
        title="Filtro"
        hiddenHelpButton
      >
        <Grid item xs={12} style={{ width: '370px' }}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography
                style={{ fontSize: '16px', fontWeight: 'normal' }}
                color={colors.primary}
              >
                Utilize os campos abaixo para encontrar <br /> um item de
                atendimento
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid
                container
                spacing={1}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item sm={6} xs={12} lg={6}>
                  <TextField
                    name="id"
                    label="Número da OS"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.id || ''}
                  />
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <TextField
                    name="name"
                    label="Nome"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.name}
                  />
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <InputMask
                    mask={
                      form.phone?.replace(/[^\d]/g, '').length <= 10
                        ? '(99) 9999-9999?'
                        : '(99) 99999-9999'
                    }
                    formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
                    maskChar=""
                    name="phone"
                    value={form.phone}
                    onChange={e => {
                      setForm({
                        ...form,
                        phone: e.target.value.replace(/[^\d]/g, ''),
                      })
                    }}
                  >
                    {inputProps => (
                      <TextField
                        {...inputProps}
                        label="Telefone"
                        fullWidth
                        variant="standard"
                      />
                    )}
                  </InputMask>
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <SelectField
                    options={statuses}
                    setForm={handleChangeStatus}
                    data={form.status || ''}
                    variant="standard"
                    name="status"
                    label="Status"
                  />
                </Grid>

                <Grid item xs={12}>
                  <SelectField
                    options={attendants}
                    setForm={handleChangeAttendance}
                    data={form.attendant || null}
                    name="attendant"
                    variant="standard"
                    label="Atendente"
                  />
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <KeyboardDatePicker
                    clearable
                    value={
                      form?.date_start ||
                      (filters?.date_start
                        ? `${filters?.date_start} 00:00:00`
                        : null)
                    }
                    label="Data Inicial"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    inputVariant="standard"
                    onChange={date => handleChangeDate(date, 'date_start')}
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <KeyboardDatePicker
                    clearable
                    value={
                      form.date_end ||
                      (filters?.date_end
                        ? `${filters?.date_end} 00:00:00`
                        : null)
                    }
                    label="Data Final"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    name="date_end"
                    inputVariant="standard"
                    onChange={date => handleChangeDate(date, 'date_end')}
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <TextField
                    select
                    label="Possui pagamento?"
                    fullWidth
                    name="has_billing"
                    variant="standard"
                    defaultValue={filters?.has_billing || ''}
                  >
                    <MenuItem key="" value="">
                      Selecione...
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                      Com pagamento
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      Sem pagamento
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                      Com pagamento parcial
                    </MenuItem>
                  </TextField>
                </Grid>

                <Grid item sm={6} xs={12} lg={6}>
                  <TextField
                    name="bar_code"
                    label="Etiqueta"
                    className={classes.inputFilter}
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.bar_code || ''}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Button
                    type="submit"
                    color={colors.primary}
                    variant="contained"
                    className={formClasses.btnSubmmit}
                    onClick={toggleModal}
                  >
                    <SearchIcon />
                    {` Pesquisar`}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </BaseFilterModal>
    </BaseFilter>
  )
}
